/* eslint-disable max-statements */
import { Component, ElementRef, OnDestroy, ViewChild, ViewEncapsulation, } from '@angular/core'
import { UntypedFormControl } from '@angular/forms'
import { Meta, Title } from '@angular/platform-browser'
import { ActivatedRoute, Router } from '@angular/router'
import { of, Subscription, switchMap, take, tap } from 'rxjs'
import { DataFilters } from 'src/app/models/DataFilters.model'
import {
  ASSET_CLASS_FILTERS,
  INVESTMENT_MINIMUM_FILTERS,
  MANAGEMENT_STYLE_FILTERS,
  REGION_FILTERS,
  SHARE_CLASS_FILTERS,
  STRATEGY_FILTERS,
  STRATEGY_FILTERS_529,
  TAX_EFFICIENCY_FILTERS,
} from 'src/app/models/filter-details.model'
import { FundFamilyDetails } from 'src/app/models/fund-details.model'
import { AdobeLaunchService } from 'src/app/services/adobe-launch.service'
import { AEMChunk } from 'src/app/services/AEM/aem-chunk.model'
import { ApplicationStateService } from 'src/app/services/application-state.service'
import { CentralContentService } from 'src/app/services/content/central-content.service'
import { FiltersService } from 'src/app/services/filtersService.service'
import { FundDetailService } from 'src/app/services/fund-detail.service'
import { LoadingService } from 'src/app/services/loading.service'
import { SeoService } from 'src/app/services/seo/seo.service'
import { environment } from 'src/environments/environment'

// CaaS content imports
import { FundDetailsService } from '../../services/fund-details.service'
import { ResultsComponent } from '../tabs/results/results.component'
import { ResultsComponentMobile } from '../tabs/results/results.component.mobile'
import { ProductTypeFilterComponent } from "../filters/productTypeFilter/productTypeFilter.component";

const MUTUAL_FUNDS = 'Mutual funds'
const NON_VANGUARD_MUTUAL_FUNDS = 'non-vanguard-mutual-funds'
const _529_PLAN_PORTFOLIOS = '529 plan portfolios'

@Component({
  selector: 'VFA-list-page',
  templateUrl: './list-page.component.html',
  styleUrls: ['./list-page.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class ListPageComponent implements OnDestroy {
  @ViewChild('fundFamilySelect') fundFamilySelect: ElementRef<HTMLElement>
  @ViewChild(ResultsComponent) resultComponent: ResultsComponent
  @ViewChild(ResultsComponentMobile)
  resultComponentMobile: ResultsComponentMobile

  public activeFilters: DataFilters
  public title = ''
  filterBy = ''
  numOfResults = 0
  numTotalResults = 0
  NVGnumTotalResults = 0
  numAppliedFilters = 0
  // AEM content Vars
  pastPerformance: AEMChunk
  performanceDataForPeriods: AEMChunk
  forMoreInformation: AEMChunk
  municipalMoneyMarket: AEMChunk
  vanguardCashReserves: AEMChunk
  educational529Link: AEMChunk
  vanguardBrokerageServices: AEMChunk
  collegeSavingsPlan: AEMChunk
  beforeInvestingIn529: AEMChunk
  vanguardInvestmentManager: AEMChunk
  subjectToRisk: AEMChunk
  nonVanguardSECYield: AEMChunk
  noTransactionFee: AEMChunk
  allTransactionsSubj: AEMChunk
  nonVanguardThirdParty: AEMChunk
  nonVanguardMFFees: AEMChunk
  aemContentSub: Subscription
  // CaaS content vars
  etfLink: string
  pdfLink529: string
  productType: string


  link: string
  public fundFamilyDetails: FundFamilyDetails[];
  public readonly fundFamily: UntypedFormControl = new UntypedFormControl('')
  public accountingTypeOptions = {
    all: 'Mutual funds & ETFs',
    'mutual-funds': MUTUAL_FUNDS,
    etfs: 'ETFs',
    '529-portfolios': _529_PLAN_PORTFOLIOS,
    'non-vanguard-mutual-funds': MUTUAL_FUNDS
  }

  isNvmf = false;
  showFilters = true;
  isOnLoad: boolean
  public isMobileResolution: boolean
  adobeLaunchPage: any
  openFilterView: boolean
  closeFilters = false
  viewSwitch = true
  public detailViewSwitch = true
  subtitle: any
  metaContent: any
  pageTitle: any
  initialPageLoad = false;
  fundFamilyName: any;
  fundFamilyId: any;
  hasLoadFunds: boolean;
  hasNTFFunds: boolean;
  fundFamilySelection: string
  public productTypeFilterComponent: ProductTypeFilterComponent;
  /*eslint max-params: ["error", 11]*/
  // eslint-disable-next-line max-params
  constructor(
    private readonly fund: FundDetailsService,
    private readonly route: ActivatedRoute,
    public filtersService: FiltersService,
    public adobeLaunchService: AdobeLaunchService,
    public readonly router: Router,
    private readonly applicationStateService: ApplicationStateService,
    private readonly fundDetailService: FundDetailService,
    private readonly centralContentService: CentralContentService,
    private readonly titleService: Title,
    private readonly metaService: Meta,
    public readonly seoService: SeoService,
    private readonly loadingService: LoadingService,
  ) { }

  // eslint-disable-next-line max-statements
  ngOnInit(): void {
    this.disclaimerLink()
    this.initialPageLoad = true;
    this.isOnLoad = true
    this.loadingService.setLoading(true)

    this.route.queryParams.subscribe(({filters}) => {
      if(filters === undefined){
        this.filtersService.openFilters = true;
      }
    })

    if (!this.filtersService.FundFamilyId) {
      this.filtersService.activeFilters.discoverBy = 'mutual-funds';
    }

    // Fetch fund details and process the response
    this.fundDetailService.getfunddetail()
      .pipe(
        tap((response) => {
          this.fund.updateFundDetails(response); // Update fund details with the response
          this.numTotalResults = response?.fund?.entity?.length; // Set total number of results
          this.productTypeTotalResults(); // Calculate results based on product type
        }),
        switchMap(() => {
          // If a FundFamilyId exists, fetch its details
          if (this.filtersService.FundFamilyId !== undefined) {
            return this.fundDetailService.getfundFamilyDetail(this.filtersService.FundFamilyId).pipe(take(1));
          }
          return of(null); // Return null if no FundFamilyId
        })
      )
      .subscribe((response) => {
        if (response) {
          this.fund.updateFundFamilyDetails(response); // Update fund family details
        }
        this.filtersService.applyFilters(); // Apply filters after all updates
      });

    this.filtersService.filteredData$.subscribe((filteredResults) => {
      if (filteredResults !== null && filteredResults !== undefined && filteredResults.fund?.entity?.length !== undefined) {
        setTimeout(() => {
          this.loadingService.setLoading(false)
        }, // eslint-disable-next-line @typescript-eslint/no-magic-numbers
          600)
        this.numOfResults = filteredResults.fund?.entity?.length || 0
        this.numAppliedFilters = this.filtersService.numAppliedFilters
      } else {
        this.numOfResults = 0
      }
    })

    this.aemContentSub = this.centralContentService.aemContent$.subscribe(
      (content) => {
        this.parseAEMContent(content)
      },
    )

    this.route.params.subscribe((params) => {
      const key = Object.keys(this.accountingTypeOptions).find(
        (key) => key === params.accountingType,
      )
      if (key) {
        this.productType = key
        this.setTitleMeta(key)
        this.seoService.createLinkForCanonicalURL(key)
        this.filtersService.activeFilters.discoverBy = key
        this.fetchFundFamilyNameForHeader();
      } else {
        this.router.navigate(['all'])
      }
    })

    this.onResize()
    this.adobeLaunchPage = {
      pageTemplate: 'funds list',
    }
    this.adobeLaunchService.initializePage(
      this.adobeLaunchPage,
      environment.adobeLaunchEnv,
    )
  }

  get filtersLabel(): string {
    const count = this.numAppliedFilters ?? 0;
    return `Filters (${count})`; 
  }

  fetchFundFamilyNameForHeader(): void {
    // Purpose of this method is to get Fund family name dynamically for Page Headline
    this.fundDetailService.getfundFamily()
    // eslint-disable-next-line complexity
    .subscribe((response) => {
      this.fundFamilyDetails = response.fundFamily;
      const isNvmf = this.filtersService.activeFilters.discoverBy === 'non-vanguard-mutual-funds'

      const foundFamily = this.fundFamilyDetails.find(
        family => String(family.fundFamilyId) === this.filtersService.FundFamilyId
      );

      if (foundFamily) {
        this.fundFamilyName = foundFamily.fundFamilyName;
        this.hasLoadFunds = foundFamily.hasLoadFunds;
        this.hasNTFFunds = foundFamily.hasNTFFunds;
        this.fundFamilySelection = `${this.fundFamilyName}${this.hasLoadFunds ? ' [Load]' : ''}${this.hasNTFFunds ? ' [NTF]' : ''} mutual funds`;
      }

      if(!foundFamily && isNvmf) {
        this.filtersService.activeFilters.discoverBy = 'mutual-funds';
      }
    });
  }

  productTypeTotalResults() {
    const conditions = [];
    if (this.activeFilters) {
      if (this.activeFilters.discoverBy !== 'all' && this.activeFilters.discoverBy !== NON_VANGUARD_MUTUAL_FUNDS) {
        conditions.push(
          (fund) =>
            fund.profile[this.filtersService.discoverByMap[this.activeFilters.discoverBy]] ===
            true,
        )
      } else if (this.activeFilters.discoverBy === 'all') {
        conditions.push(
          (fund) =>
            fund.profile['isETF'] === true ||
            fund.profile['isMutualFund'] === true,
        )
      }
      this.numTotalResults = this.fund.fundDetails$.getValue()?.fund?.entity?.filter((fund) => conditions.every((c) => c(fund))).length;
    }
  }

  parseAEMContent(content) {
    {
      this.educational529Link = this.centralContentService.getContentByBody(
        'fund_definitions_529_informational_link',
        content,
      )
      this.pastPerformance = this.centralContentService.getContentByBody(
        'disclaimer_past_performance',
        content,
      )
      this.performanceDataForPeriods = this.centralContentService.getContentByBody(
        'disclaimer_performance_data_for_periods',
        content,
      )
      this.forMoreInformation = this.centralContentService.getContentByBody(
        'disclaimer_for_more_information',
        content,
      )
      this.municipalMoneyMarket = this.centralContentService.getContentByBody(
        'disclaimer_municipal_money_market',
        content,
      )
      this.vanguardCashReserves = this.centralContentService.getContentByBody(
        'disclaimer_vanguard_cash_reserves',
        content,
      )
      this.vanguardBrokerageServices = this.centralContentService.getContentByBody(
        'disclaimer_vanguard_brokerage_services',
        content,
      )
      this.collegeSavingsPlan = this.centralContentService.getContentByBody(
        'disclaimer_529_college_savings_plan',
        content,
      )
      this.beforeInvestingIn529 = this.centralContentService.getContentByBody(
        'disclaimer_before_investing_in_529',
        content,
      )
      this.vanguardInvestmentManager = this.centralContentService.getContentByBody(
        'disclaimer_vanguard_investment_manager',
        content,
      )
      this.subjectToRisk = this.centralContentService.getContentByBody(
        'disclaimer_investing_is_subject_to_risk',
        content,
      )
      this.nonVanguardSECYield = this.centralContentService.getContentByBody(
        'footnote_non_vanguard_sec_yield',
        content,
      )
      this.noTransactionFee = this.centralContentService.getContentByBody(
        'footnote_no_transaction_fee',
        content,
      )
      this.allTransactionsSubj = this.centralContentService.getContentByBody(
        'disclaimer_all_transactions_subject_brokerage_commissions',
        content,
      )
      this.nonVanguardThirdParty = this.centralContentService.getContentByBody(
        'disclaimer_non_vanguard_third_party_price_calculations',
        content,
      )
      this.nonVanguardMFFees = this.centralContentService.getContentByBody(
        'disclaimer_non_vanguard_mf_fees_and_minimums',
        content,
      )
    }
  }

  setTitleMeta(key) {
    const SEARCH_DIRECTIVE = "name=Search-directive"
    switch (key) {
      case "mutual-funds": {
        this.isNvmf = false;
        this.subtitle = "mutual funds"
        this.pageTitle = "Vanguard Mutual Funds List | Vanguard"
        this.metaContent = ` Browse a list of Vanguard mutual funds, including product summaries, performance details, and pricing.`
        this.metaService.removeTag(SEARCH_DIRECTIVE)
        break;
      }
      case "529-portfolios": {
        this.isNvmf = false;
        this.subtitle = "529 plan portfolios"
        this.pageTitle = "Vanguard 529 Portfolio List | Vanguard"
        this.metaContent = ` Explore a list of Vanguard 529 Portfolios, including current portfolio performance, asset allocation, expense ratios, and other fund research.`
        this.metaService.removeTag(SEARCH_DIRECTIVE)
        break;
      }
      case "etfs": {
        this.isNvmf = false;
        this.subtitle = "ETFs"
        this.pageTitle = "Vanguard ETFs List | Vanguard"
        this.metaContent = ` Browse a list of Vanguard's ETFs, including performance details for both index and active ETFs.`
        this.metaService.removeTag(SEARCH_DIRECTIVE)
        break;
      }
      case "non-vanguard-mutual-funds": {
        this.isNvmf = true;
        this.subtitle = "mutual funds"
        this.pageTitle = "Non-Vanguard Mutual Funds | Vanguard"
        this.metaContent = `View a list of all non-Vanguard mutual funds, including product summaries and performance details.`
        this.metaService.addTag({ name: 'Search-directive', content: "noindex, nofollow" }, false)
        break;
      }
      default: {
        this.isNvmf = false;
        this.subtitle = "mutual funds & ETFs"
        this.pageTitle = "Vanguard Investment Products List | Vanguard"
        this.metaContent = ` As one of the largest investment companies, Vanguard offers various investment products to suit your investing needs. Browse our mutual funds and ETFs today.`
        this.metaService.removeTag(SEARCH_DIRECTIVE)
        break;
      }
    }
    this.titleService.setTitle(this.pageTitle)
    this.metaService.updateTag({ name: 'DESCRIPTION', content: this.metaContent })

  }

  disclaimerLink() {
    this.etfLink = environment.etfDisclaimerLink
    this.pdfLink529 = environment.pdfDisclaimerLink529
  }

  ngOnDestroy(): void {
    this.aemContentSub.unsubscribe()
  }

  clearFilters() {
    this.filtersService.clearFilters()
  }
  onResize() {
    this.isMobileResolution = this.applicationStateService.getIsMobileResolution()
    this.openFilterView = this.isMobileResolution;
  }

  clearCheckbox() {
    // eslint-disable-next-line @typescript-eslint/no-magic-numbers
    if (window.innerWidth <= 576) {
      this.resultComponentMobile.comparedFunds = []
    } else {
      this.resultComponent.comparedFunds = []
    }
  }
  formatLink(str) {
    const from = ['&lt;', '&gt;', '&amp;', '&quot;', '>nbsp;', '&nbsp;']
    const to = ['<', '>', '&', '"', ' ', ' ']
    from.forEach((data, index) => {
      str = this.regularExpression(str, data, to[index])
    })
    return str
  }
  regularExpression(str, find, replace) {
    // eslint-disable-next-line @typescript-eslint/no-magic-numbers
    const escapedFind = find.replace(/([.*+?^=!:${}()|\[\]\/\\])/g, '\\$1')
    return str.toString().replace(new RegExp(escapedFind, 'g'), replace)
  }
  setdetailedViewValue($event) {
    this.detailViewSwitch = $event
  }
  setopenFilterValue($event) {
    this.openFilterView = $event
    this.closeFilters = false;
  }
  // eslint-disable-next-line complexity
  areAllFiltersEmpty(): boolean {
    this.activeFilters = this.filtersService.activeFilters
    if (this.activeFilters) {
      const isRiskEmpty = this.activeFilters.risk?.length === 0
      const isAssetClassEmpty =
        ASSET_CLASS_FILTERS.filter(
          (value) => this.activeFilters.assetClass?.controls[value].value,
        ).length <= 0

      const isShareClassArrayEmpty =
        SHARE_CLASS_FILTERS.filter(
          (value) => this.activeFilters.shareClass?.controls[value].value,
        ).length <= 0
      const istaxEfficiencyArrayEmpty =
        TAX_EFFICIENCY_FILTERS.filter(
          (value) => this.activeFilters.taxEfficiency?.controls[value].value,
        ).length <= 0
      const isManagementStyleArrayEmpty =
        MANAGEMENT_STYLE_FILTERS.filter(
          (value) => this.activeFilters.managementStyle?.controls[value].value,
        ).length <= 0
      const isInvestmentMinimumsArrayEmpty =
        INVESTMENT_MINIMUM_FILTERS.filter(
          (value) => this.activeFilters.investmentMinimums?.controls[value].value,
        ).length <= 0
      const isStrategyEmpty = STRATEGY_FILTERS.filter(
        (value) => this.activeFilters.strategy?.controls[value].value,
      ).length <= 0
      const isStrategy529Empty = STRATEGY_FILTERS_529.filter(
        (value) => this.activeFilters.strategy529?.controls[value].value,
      ).length <= 0
      const isRegionEmpty = REGION_FILTERS.filter(
        (value) => this.activeFilters.region?.controls[value].value,
      ).length <= 0
      return (
        isRiskEmpty &&
        isAssetClassEmpty &&
        isManagementStyleArrayEmpty &&
        isShareClassArrayEmpty &&
        isInvestmentMinimumsArrayEmpty &&
        isStrategyEmpty &&
        istaxEfficiencyArrayEmpty &&
        isRegionEmpty &&
        isStrategy529Empty
      )
    } else {
      return true;
    }
  }

  filteredCount() {
    if (!this.areAllFiltersEmpty()) {
      return `<span><strong>${this.numOfResults}</strong> of ${this.isNvmf ? this.NVGnumTotalResults : this.numTotalResults} results</span>`;
    } else {
      return `<span class="results-align-right">${this.numOfResults} results</span> `;
    }
  }

  filteredCountDetailView() {
    if (!this.areAllFiltersEmpty()) {
      return `<span><strong>${this.numOfResults} </strong> of ${this.isNvmf ? this.NVGnumTotalResults : this.numTotalResults} results</span>`;
    } else {
      return `<span class="results-detailview">${this.numOfResults} results</span> `;
    }
  }

  openFilters() {
    if (this.closeFilters === false) {
      this.openFilterView = false
      this.closeFilters = true
      this.adobeLaunchService.subPageTabEvent(
        `${this.filtersService.activeFilters.discoverBy}:filters-action:button:closed`,
      )

      this.filtersService.openFilters = false;
      this.filtersService.applyChangesToUrlParams({filters: 'closed'})
    } else {
      this.closeFilters = false;
    }
  }

}

